export enum IconBoxTypeEnum {

    Image = 'image',

    Icon = 'icon',

}
